export default __webpack_public_path__ + "static/media/toolbar-emoji.c06530e9.svg";